var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGemini(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gemini") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gemini",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9864,5.5221 C8.2824,5.2991 7.6134,5.0021 6.9864,4.6361 L6.9864,19.3641 C7.6134,18.9981 8.2824,18.7011 8.9864,18.4781 L8.9864,5.5221 Z",
    id: "Left-Column",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9864,18.4779 C15.6904,18.7009 16.3594,18.9979 16.9864,19.3639 L16.9864,4.6359 C16.3594,5.0019 15.6904,5.2989 14.9864,5.5219 L14.9864,18.4779 Z",
    id: "Right-Column",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9864,19.3639 C16.3594,18.9979 15.6904,18.7009 14.9864,18.4779 C14.0384,18.1779 13.0354,17.9999 11.9864,17.9999 C10.9374,17.9999 9.9344,18.1779 8.9864,18.4779 C8.2824,18.7009 7.6134,18.9979 6.9864,19.3639 C5.8254,20.0409 4.8044,20.9309 4.0004,21.9999 L6.7124,21.9999 C8.1224,20.7589 9.9654,19.9999 11.9864,19.9999 C14.0074,19.9999 15.8504,20.7589 17.2604,21.9999 L19.9724,21.9999 C19.1684,20.9309 18.1474,20.0409 16.9864,19.3639",
    id: "Bottom",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9864,6 C13.0354,6 14.0384,5.822 14.9864,5.522 C15.6904,5.299 16.3594,5.002 16.9864,4.636 C18.1474,3.96 19.1684,3.069 19.9724,2 L17.2604,2 C15.8504,3.241 14.0074,4 11.9864,4 C9.9654,4 8.1224,3.241 6.7124,2 L4.0004,2 C4.8044,3.069 5.8254,3.96 6.9864,4.636 C7.6134,5.002 8.2824,5.299 8.9864,5.522 C9.9344,5.822 10.9374,6 11.9864,6",
    id: "Top",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemini);
export default __webpack_public_path__ + "static/media/gemini.b52898310465f61a11e8be3fda86af58.svg";
export { ForwardRef as ReactComponent };